// ** Components
import Message from "./Message";
import { CardBody } from "components/layout/Card/CardBody";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardsBlockWrapper } from "components/layout/Card/CardsBlockWrapper";
import MediaPost_useInView from "components/user/MediaPosts/MediaPost_useInView";

// #####################################################

const NotificationsPresenter = ({ data }) => {
	// #####################################################

	return (
		<CardsBlockWrapper>
			{data?.map(({ data, date, id, type }, index) => {
				const media_type = Object.keys(data)[1];

				return (
					<CardWrapper key={index}>
						{media_type === "post" ||
						media_type === "photo" ||
						media_type === "video" ? (
							<MediaPost_useInView
								item={{ ...data[media_type], media_type }}
								user={{
									...data.user,
									user_id: data.user.id,
								}}
								sizePost="large_post"
							/>
						) : (
							<CardBody key={id}>
								<Message
									deletedUser={data.deletedUser}
									user={data.user}
									date={date}
									type={type}
									birthday={data?.birthday || null}
								/>
							</CardBody>
						)}
					</CardWrapper>
				);
			})}
		</CardsBlockWrapper>
	);
};

// #####################################################

export default NotificationsPresenter;

// #####################################################
